import {
  HomeAwayChannelConfig,
  HomeAwayRentalConfig,
  HomeToGoChannelConfig,
  HomeToGoRentalConfig,
} from './channels.model'
import { Dictionary } from '@ngrx/entity'
import { ChannelNameTokens } from '@tokeet/tv3-platform'
import { TiketState } from './tiket/state'
import { GVRListingModel, GVRStatus } from './gvr/model'
import { RentalsUnitedStatus, RentalsUnitedListingModel } from './rentals-united/model'
import { HoliduStatus, HoliduListingModel } from './holidu'
import { HvmiListingModel, HvmiStatus } from './hvmi'
import { ListingsValidationFieldResult } from './rental-validation-field'
import { CtripState } from './ctrip/state'

export interface State {
  configLoaded: Dictionary<boolean>
  rentalConfigs: Dictionary<(HomeToGoRentalConfig | HomeAwayRentalConfig)[]>
  configs: Dictionary<HomeToGoChannelConfig | HomeAwayChannelConfig>
  hvmi: {
    status: HvmiStatus
    listings: HvmiListingModel[]
    validations: ListingsValidationFieldResult
    validationsLoaded: boolean
  }
  rentalUnited: {
    status: RentalsUnitedStatus
    listings: RentalsUnitedListingModel[]
    validations: ListingsValidationFieldResult
    validationsLoaded: boolean
  }
  holidu: {
    status: HoliduStatus
    listings: HoliduListingModel[]
    validations: ListingsValidationFieldResult
    validationsLoaded: boolean
  }
  tiket: TiketState
  gvr: {
    status: GVRStatus
    listings: GVRListingModel[]
    validations: ListingsValidationFieldResult
    validationsLoaded: boolean
  }
  ctrip: CtripState
}

export const initialState: State = {
  configLoaded: {
    [ChannelNameTokens.HomeToGo]: false,
    [ChannelNameTokens.Homeaway]: false,
  },
  configs: {},
  rentalConfigs: {},
  hvmi: {
    status: null,
    listings: [],
    validations: {},
    validationsLoaded: false,
  },
  holidu: {
    status: null,
    listings: [],
    validations: {},
    validationsLoaded: false,
  },
  rentalUnited: {
    status: null,
    listings: [],
    validations: null,
    validationsLoaded: false,
  },
  tiket: {
    status: null,
    listings: [],
  },
  gvr: {
    status: null,
    listings: [],
    validations: {},
    validationsLoaded: false,
  },
  ctrip: {
    status: null,
    listings: [],
  },
}
